import React, { useState, useEffect, useContext } from "react";
import "./index.scss";
import { useNavigate, useParams } from "react-router";
import {
  convertToCamelCaseFromUnderScore,
  checkForUserLimit,
} from "../../../utils";
import {
  TICKET_SEVERITY,
  TICKET_STAGES,
  USER_LIMITS,
} from "../../../utils/constants";
import {
  IconButton,
  InputAdornment,
  Grid,
  Box,
  Stack,
  Button,
} from "@mui/material";
import CustomModal from "../../../core/modal";
import { invokeApi, HTTP_METHODS, plainApi } from "../../../utils/http-service";
import { HOSTNAME, REST_URLS } from "../../../utils/endpoints";
import { toast } from "react-toastify";
import { Edit } from "@mui/icons-material";
import StaticForm from "../../../components/static-form";
import {
  BASIC_FORM3,
  CUT_IN,
  FINAL_ACTION_LIST,
  REASONS_FOR_ENGINE_REPLACEMENT,
  WARRANTY_STATUS,
} from "./helper";
import SiAutocomplete from "../../../core/si-autocomplete";
import SiFileUpload from "../../../core/file-uploader";
import SiTextField from "../../../core/si-textfield";
import CustomButtonComponent from "../../../core/custom-button";
import AppContext from "../../../utils/context";
import { Icon } from "@iconify/react";
import ThumbUpAltTwoToneIcon from "@mui/icons-material/ThumbUpAltTwoTone";
import ThumbDownOffAltTwoToneIcon from "@mui/icons-material/ThumbDownOffAltTwoTone";
import RowRadioButtonsGroup from "../../../core/radio-group";
import ViewTicket from "../../../components/service-tickets/view-ticket";
import ViewBasicForm from "./view-basic-form";
import moment from "moment";
import { TICKET_STATUS } from "../../../core/ticket-filters/config";
const BasicInfo2 = ({
  ticketDetails,
  serviceEngineers = [],
  loadData,
  complaintForm,
  codes,
  parts,
  loadParts,
  setShowAttachments,
}) => {
  const { severity, stage = "" } = ticketDetails;
  const { id = "" } = useParams();
  const navigate = useNavigate();
  const [engineer, setEngineer] = useState({});
  const [reassign, setReassign] = useState(false);
  const [updateDefectCode, setUpdateDefectCode] = useState(false);
  const [updateActionCode, setUpdateActionCode] = useState(false);
  const [viewTicket, setViewTicket] = useState(null);
  const [lastStageFormData, setLastStageFormData] = useState({});
  const [approverList, setApproverList] = useState([]);
  const [tempDate, setTempDate] = useState("");
  const [comment, setComment] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [message, setMessage] = useState("");
  const [actionCodeList, setActionCodeList] = useState([]);
  const [defectCodeList, setDefectCodeList] = useState([]);
  const [updateClosedAt, setUpdateClosedAt] = useState({
    isOpen: false,
    date: "",
  });
  const [ticketSeverity, setTicketSeverity] = useState({
    isOpen: false,
    severity: "",
  });
  const [updatedData, setUpdatedData] = useState({});
  const [selectedActionCode, setSelectedActionCode] = useState({});
  const [updateInvoiceDate, setUpdateInvoiceDate] = useState({
    isOpen: false,
    date: "",
  });
  const [partReplacementPayload, setPartReplacementPayload] = useState({
    mode: "",
    scope: "",
    listOfParts: [],
    extra: "",
  });
  const [engineReplacementPayload, setEngineReplacementPayload] = useState({
    replacementBy: "",
    engineType: "",
    engineTypeValue: null,
    extraText: "",
    mode: "",
  });
  const [isUpdateTicket, setIsUpdateTicket] = useState({
    isOpen: false,
    type: "",
    value: "",
  });
  const { userDetails = {} } = useContext(AppContext);
  const addComments = () => {
    invokeApi(HTTP_METHODS.POST, `${HOSTNAME}${REST_URLS.COMMENT}/${id}`, {
      comment,
    })
      .then((response) => {
        if (response?.message) {
          toast.error("Update Failed");
        } else {
          toast.success("Comment Added");
          setComment("");
          loadData();
        }
      })
      .catch((err) => console.error(err));
  };
  const updateSeverityInspection = (value) => {
    invokeApi(HTTP_METHODS.PUT, `${HOSTNAME}${REST_URLS.TICKETS}/${id}`, {
      severity: value,
    })
      .then((response) => {
        if (response?.message) {
          toast.error("Update Failed");
        } else {
          loadData();
        }
        setTicketSeverity({
          isOpen: false,
          severity: "",
        });
      })
      .catch((err) => console.error(err));
  };

  const loadActionCodes = () => {
    plainApi(HTTP_METHODS.GET, `${HOSTNAME}${REST_URLS.GET_CODES}`, null, {
      type: "action",
      page: 1,
      limit: 1000,
    })
      .then((response) => {
        if (response.results) {
          const codeList = response.results.map((ele) => ({
            label: ele.code,
            value: ele.id,
            placeholder: `${ele.code}-${ele.description}`,
          }));
          setActionCodeList(codeList);
        }
      })
      .catch((err) => console.error(err));
  };
  const loadDefectCodes = () => {
    plainApi(HTTP_METHODS.GET, `${HOSTNAME}${REST_URLS.GET_CODES}`, null, {
      type: "defect",
      page: 1,
      limit: 1000,
    })
      .then((response) => {
        if (response.results) {
          const codeList = response.results.map((ele) => ({
            label: ele.code,
            value: ele.id,
            placeholder: `${ele.code}-${ele.description}`,
          }));
          setDefectCodeList(codeList);
        }
      })
      .catch((err) => console.error(err));
  };
  useEffect(() => {
    serviceEngineers &&
      setEngineer(
        serviceEngineers.find((s) => s.id === ticketDetails.serviceEngineerId)
      );
  }, [serviceEngineers]);

  const assignEngineer = () => {
    setReassign(false);
    if (engineer.id === ticketDetails.serviceEngineerId) {
      setReassign(false);
      setEngineer({});
      return;
    }

    invokeApi(HTTP_METHODS.PUT, `${HOSTNAME}${REST_URLS.ASSIGN_SE}/${id}`, {
      serviceEngineerId: engineer.id,
    })
      .then((response) => {
        if (response.message) {
          toast.error(`Failed to update, ${response.message}`);
        } else {
          toast.success("Service Engineer Updated Successfully");
        }
        setEngineer({});
        setReassign(false);
        loadData();
      })
      .catch((err) => console.error(err));
  };
  const updateTicket = (payload) => {
    invokeApi(
      HTTP_METHODS.PUT,
      `${HOSTNAME}${REST_URLS.TICKETS}/${id}`,
      payload
    )
      .then((response) => {
        if (response?.message) {
          toast.error("Update Failed");
        } else {
          loadData();
        }
      })
      .catch((err) => console.error(err));
  };
  const resubmitTicketHandler = () => {
    invokeApi(HTTP_METHODS.PUT, `${HOSTNAME}${REST_URLS.TICKETS}/${id}`, null, {
      reSubmit: "TRUE",
    })
      .then((response) => {
        if (response?.message) {
          toast.error("Update Failed");
        } else {
          loadData();
        }
      })
      .catch((err) => console.error(err));
  };
  const getApproverList = () => {
    invokeApi(HTTP_METHODS.GET, `${HOSTNAME}${REST_URLS.APPROVER_LIST}`)
      .then((res) => {
        if (res.message) {
          toast.error("Approvers not found");
        } else {
          const result = res.map((ele) => ({ label: ele.name, value: ele.id }));
          setApproverList(result);
        }
      })
      .catch((err) => console.error(err));
  };
  const assignApprover = (payload) => {
    invokeApi(
      HTTP_METHODS.PUT,
      `${HOSTNAME}${REST_URLS.ASSIGN_TICKET_APPROVER}/${id}`,
      payload
    )
      .then((response) => {
        if (response?.message) {
          toast.error(response.message);
        } else {
          loadData();
        }
      })
      .catch((err) => console.error(err));
  };
  const approverOrRejectHandler = (status) => {
    invokeApi(
      HTTP_METHODS.PUT,
      `${HOSTNAME}${REST_URLS.APPROVE_REJECT_ENGINE}/${id}`,
      null,
      {
        approvalStatus: status,
      }
    )
      .then((res) => {
        if (res.message) {
          toast.error(res.message);
        } else {
          toast.success("Ticket Updated");
          loadData();
        }
      })
      .catch((err) => console.error(err));
  };
  const updateDetailsHandler = () => {
    setUpdateDefectCode(false);
    invokeApi(HTTP_METHODS.PUT, `${HOSTNAME}${REST_URLS.DEFECT_ACTION}/${id}`, {
      ...updatedData,
    })
      .then((response) => {
        if (response.message) {
          toast.error(response.message);
        } else {
          setUpdatedData({});
          loadData();
        }
      })
      .catch((err) => console.error(err));
  };
  const engineReplacement = () => {
    invokeApi(
      HTTP_METHODS.PUT,
      `${HOSTNAME}${REST_URLS.A002_ACTION}/${id}`,
      engineReplacementPayload
    )
      .then((response) => {
        if (response.message) {
          toast.error(response.message);
        } else {
          setEngineReplacementPayload({
            replacementBy: "",
            engineType: "",
            engineTypeValue: null,
            extraText: "",
            mode: "",
          });
        }
      })
      .catch((err) => console.error(err));
  };
  const partReplacement = () => {
    let payload = partReplacementPayload;
    payload.listOfParts = partReplacementPayload.listOfParts.map(
      (l) => l.description
    );
    invokeApi(
      HTTP_METHODS.PUT,
      `${HOSTNAME}${REST_URLS.A003_ACTION}/${id}`,
      payload
    )
      .then((response) => {
        setPartReplacementPayload({
          mode: "",
          scope: "",
          listOfParts: [],
          extra: "",
        });
      })
      .catch((err) => console.error(err));
  };
  const updateActionCodeHandler = () => {
    if (selectedActionCode.code === "A002") {
      engineReplacement();
    } else if (selectedActionCode.code === "A003") {
      partReplacement();
    }
    updateActionCodeSubmitHandler("action");
  };

  const getActionCode002Elements = () => {
    return (
      <div>
        <RowRadioButtonsGroup
          label="Replacement Mode"
          options={["under_warranty", "goodwill_warranty"]}
          value={engineReplacementPayload.mode}
          onChange={(event) => {
            setEngineReplacementPayload({
              ...engineReplacementPayload,
              mode: event.target.value,
            });
          }}
        />
        <RowRadioButtonsGroup
          label="Replacement By"
          options={["simpsons", "oem"]}
          value={engineReplacementPayload.replacementBy}
          onChange={(event) => {
            setEngineReplacementPayload({
              ...engineReplacementPayload,
              replacementBy: event.target.value,
            });
          }}
        />
        {engineReplacementPayload.replacementBy === "simpsons" && (
          <RowRadioButtonsGroup
            label="Engine Type"
            options={["new_engine", "float_engine"]}
            value={engineReplacementPayload.engineType}
            onChange={(event) => {
              setEngineReplacementPayload({
                ...engineReplacementPayload,
                engineType: event.target.value,
              });
            }}
          />
        )}
        {engineReplacementPayload.replacementBy === "oem" && (
          <RowRadioButtonsGroup
            label="Engine Type"
            options={["from_oem_plant", "through_spd_mode", "from_oem_deposit"]}
            value={engineReplacementPayload.engineType}
            onChange={(event) => {
              setEngineReplacementPayload({
                ...engineReplacementPayload,
                engineType: event.target.value,
              });
            }}
          />
        )}
        {engineReplacementPayload.engineType &&
          engineReplacementPayload.engineTypeValue !== "float_engine" &&
          REASONS_FOR_ENGINE_REPLACEMENT[
            engineReplacementPayload.engineType
          ] && (
            <RowRadioButtonsGroup
              label="Reason for engine replacement"
              options={
                REASONS_FOR_ENGINE_REPLACEMENT[
                  engineReplacementPayload.engineType
                ]
              }
              value={engineReplacementPayload.engineTypeValue}
              onChange={(event) => {
                setEngineReplacementPayload({
                  ...engineReplacementPayload,
                  engineTypeValue: event.target.value,
                });
              }}
            />
          )}

        {engineReplacementPayload.engineType === "float_engine" ||
          (engineReplacementPayload.engineType === "from_oem_deposit" && (
            <div>
              <p>Replacement engine Sl. No</p>
              <SiTextField
                sx={{ width: "95%" }}
                size="small"
                value={engineReplacementPayload.engineTypeValue}
                onChange={(event) => {
                  setEngineReplacementPayload({
                    ...engineReplacementPayload,
                    engineTypeValue: event.target.value,
                  });
                }}
                placeholder="Replacement engine Sl. No"
              />
            </div>
          ))}

        {engineReplacementPayload.engineType && (
          <div>
            <p>Extra info</p>
            <SiTextField
              value={engineReplacementPayload.extraText}
              onChange={(event) => {
                setEngineReplacementPayload({
                  ...engineReplacementPayload,
                  extraText: event.target.value,
                });
              }}
              placeholder="Extra Info"
              sx={{ width: "95%" }}
            />
          </div>
        )}
        <Box sx={{ display: "flex", justifyContent: "center", mb: 2, mt: 2 }}>
          <CustomButtonComponent
            variant="contained"
            color="success"
            size="small"
            disabled={!selectedActionCode.value}
            onClick={updateActionCodeHandler}
            sx={{ width: "150px" }}
          >
            Submit
          </CustomButtonComponent>
        </Box>
      </div>
    );
  };
  const getActionCode003Elements = () => {
    return (
      <div>
        <RowRadioButtonsGroup
          label="Replacement Mode"
          options={["under_warranty", "goodwill_warranty"]}
          value={partReplacementPayload.mode}
          onChange={(event) => {
            setPartReplacementPayload({
              ...partReplacementPayload,
              mode: event.target.value,
            });
          }}
        />
        <RowRadioButtonsGroup
          label="Scope"
          options={["simpsons", "oem"]}
          value={partReplacementPayload.scope}
          onChange={(event) => {
            setPartReplacementPayload({
              ...partReplacementPayload,
              scope: event.target.value,
            });
          }}
        />

        <div style={{ width: "95%" }}>
          <p>Parts list </p>
          <SiAutocomplete
            multiple
            value={partReplacementPayload.listOfParts}
            options={parts}
            placeholder="Parts List"
            onChange={(newValue) => {
              const updatedList = newValue?.map((item) => ({
                ...item,
                cost: item.cost || "",
              }));
              setPartReplacementPayload({
                ...partReplacementPayload,
                listOfParts: updatedList,
              });
            }}
          />
          {partReplacementPayload?.listOfParts?.map((part, index) => (
            <Box
              key={index}
              sx={{ display: "flex", alignItems: "center", gap: 2, mt: 1 }}
            >
              <p style={{ minWidth: 100 }}>{part.part || part.label}</p>
              <SiTextField
                type="number"
                value={part.cost}
                onChange={(e) => {
                  const updatedList = [...partReplacementPayload.listOfParts];
                  updatedList[index].cost = parseFloat(e.target.value) || "";
                  setPartReplacementPayload({
                    ...partReplacementPayload,
                    listOfParts: updatedList,
                  });
                }}
                placeholder="Cost"
              />
            </Box>
          ))}
        </div>

        <div>
          <p>Extra info</p>
          <SiTextField
            value={partReplacementPayload.extra}
            onChange={(event) => {
              setPartReplacementPayload({
                ...partReplacementPayload,
                extra: event.target.value,
              });
            }}
            placeholder="Extra Info"
            sx={{ width: "95%" }}
          />
        </div>
        <Box sx={{ display: "flex", justifyContent: "center", mb: 2, mt: 2 }}>
          <CustomButtonComponent
            fullWidth
            variant="contained"
            color="success"
            disabled={!selectedActionCode.value}
            onClick={updateActionCodeHandler}
            sx={{ width: "150px" }}
          >
            Submit
          </CustomButtonComponent>
        </Box>
      </div>
    );
  };
  const updateActionCodeSubmitHandler = (type) => {
    setUpdateActionCode(false);
    let payload = {
      code: selectedActionCode.value,
      type: type,
    };
    if (selectedActionCode.label === "A002") {
      payload["engineReplacementInfo"] = engineReplacementPayload;
    }
    if (selectedActionCode.label === "A003") {
      const listOfParts = partReplacementPayload.listOfParts.map((l) => ({
        part: l.label,
        cost: l.cost,
      }));
      payload["partsReplacementInfo"] = {
        ...partReplacementPayload,
        listOfParts,
      };
    }
    invokeApi(
      HTTP_METHODS.PUT,
      `${HOSTNAME}${REST_URLS.UPDATE_ACTION_CODE}/${id}`,
      payload
    )
      .then((response) => {
        if (response.message) {
          toast.error(response.message);
        } else {
          setSelectedActionCode({});
          loadData();
        }
      })
      .catch((err) => console.error(err));
  };
  useEffect(() => {
    if (
      ticketDetails.stage === TICKET_STAGES.ENGINE_REPLACEMENT_REQ_SUBMITTED &&
      checkForUserLimit(USER_LIMITS.ADMIN, userDetails.limits)
    ) {
      getApproverList();
    }
  }, [ticketDetails]);

  return (
    <div>
      <div className="form-con pr " style={{ maxHeight: "max-content" }}>
        <div className="updated-on-date">
          Updated on {moment(ticketDetails.updatedAt).format("DD/MM/YYYY")}
        </div>

        <Grid container sx={{ display: "flex", alignItems: "center", mb: 1.5 }}>
          <Grid item md={6} xs={12} sx={{ mb: { md: 0, xs: 1 } }}>
            Complaint Severity
          </Grid>
          <Grid item md={6} xs={12}>
            <div
              className="severity-val"
              onClick={() => {
                if (
                  checkForUserLimit(USER_LIMITS.ADMIN, userDetails.limits) &&
                  ticketDetails.status !== "CLOSED"
                ) {
                  setTicketSeverity({
                    isOpen: true,
                    ticketSeverity: ticketDetails.severity,
                  });
                }
              }}
            >
              {ticketDetails.severity || "MINOR"}
            </div>
          </Grid>
        </Grid>
        <Grid container sx={{ display: "flex", alignItems: "center", mb: 2 }}>
          <Grid item md={6} xs={12} sx={{ mb: { md: 0, xs: 1 } }}>
            Invoice Date
          </Grid>
          <Grid item md={6}>
            <SiTextField
              size="small"
              fullWidth
              disabled={true}
              value={
                ticketDetails?.invoiceDate
                  ? `${moment(ticketDetails.invoiceDate).format("DD/MM/YYYY")}`
                  : ""
              }
              InputProps={{
                endAdornment: checkForUserLimit(
                  USER_LIMITS.ADMIN,
                  userDetails.limits
                ) &&
                  ticketDetails.status !== "CLOSED" && (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => {
                          setUpdateInvoiceDate({
                            isOpen: true,
                            date: ticketDetails?.invoiceDate
                              ? moment(ticketDetails.invoiceDate).format(
                                  "YYYY-MM-DD"
                                )
                              : "",
                          });
                        }}
                        sx={{ p: 0 }}
                      >
                        <Edit color="primary" fontSize="small" />
                      </IconButton>
                    </InputAdornment>
                  ),
              }}
            />
          </Grid>
        </Grid>
        <Grid container sx={{ display: "flex", alignItems: "center", mb: 2 }}>
          <Grid item md={6} xs={12} sx={{ mb: { md: 0, xs: 1 } }}>
            List Number
          </Grid>
          <Grid item md={6}>
            <SiTextField
              size="small"
              fullWidth
              disabled={true}
              value={ticketDetails.listNumber}
              InputProps={{
                endAdornment: checkForUserLimit(
                  USER_LIMITS.ADMIN,
                  userDetails.limits
                ) &&
                  !ticketDetails.listNumber &&
                  ticketDetails.status !== "CLOSED" && (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => {
                          setIsUpdateTicket({
                            isOpen: true,
                            type: "listNumber",
                          });
                        }}
                      >
                        <Edit color="primary" fontSize="small" />
                      </IconButton>
                    </InputAdornment>
                  ),
              }}
            />
          </Grid>
        </Grid>
        <Grid container sx={{ display: "flex", alignItems: "center", mb: 2 }}>
          <Grid item md={6} xs={12} sx={{ mb: { md: 0, xs: 1 } }}>
            Plant
          </Grid>
          <Grid item md={6}>
            <SiTextField
              size="small"
              fullWidth
              disabled={true}
              value={ticketDetails.plant}
              InputProps={{
                endAdornment: checkForUserLimit(
                  USER_LIMITS.ADMIN,
                  userDetails.limits
                ) &&
                  !ticketDetails.plant &&
                  ticketDetails.status !== "CLOSED" && (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => {
                          setIsUpdateTicket((prevVal) => ({
                            ...prevVal,
                            isOpen: true,
                            type: "plant",
                          }));
                        }}
                      >
                        <Edit color="primary" fontSize="small" />
                      </IconButton>
                    </InputAdornment>
                  ),
              }}
            />
          </Grid>
        </Grid>
        <Grid container sx={{ display: "flex", alignItems: "center", mb: 2 }}>
          <Grid item md={6} xs={12} sx={{ mb: { md: 0, xs: 1 } }}>
            Under Warranty
          </Grid>
          <Grid item md={6}>
            <SiTextField
              size="small"
              fullWidth
              disabled={true}
              value={
                WARRANTY_STATUS?.find(
                  (ele) => ele.value === ticketDetails.underWarranty
                )?.label || "-"
              }
              InputProps={{
                endAdornment: checkForUserLimit(
                  USER_LIMITS.ADMIN,
                  userDetails.limits
                ) &&
                  ticketDetails.status !== "CLOSED" && (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => {
                          setIsUpdateTicket((prevVal) => ({
                            ...prevVal,
                            isOpen: true,
                            type: "underWarranty",
                          }));
                        }}
                      >
                        <Edit color="primary" fontSize="small" />
                      </IconButton>
                    </InputAdornment>
                  ),
              }}
            />
          </Grid>
        </Grid>
        <Grid container sx={{ display: "flex", alignItems: "center", mb: 1 }}>
          <Grid item md={6} xs={12} sx={{ mb: { md: 0, xs: 1 } }}>
            Cut In
          </Grid>
          <Grid item md={6} xs={12}>
            <SiTextField
              size="small"
              fullWidth
              disabled={true}
              value={convertToCamelCaseFromUnderScore(ticketDetails.cutIn)}
            />
          </Grid>
        </Grid>
        <p className="form-header"> View / Download</p>
        <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
          <CustomButtonComponent
            variant="contained"
            fullWidth
            sx={{ marginRight: 2 }}
            onClick={() => setViewTicket(true)}
          >
            View Form
          </CustomButtonComponent>
          <CustomButtonComponent
            variant="contained"
            onClick={() => setShowAttachments(true)}
            fullWidth
          >
            View Attachments
          </CustomButtonComponent>
        </Box>
        {ticketDetails?.jointInspectionReport && (
          <div>
            {ticketDetails?.jointInspectionReport?.status === "PUBLISHED" && (
              <Box sx={{ display: "flex", justifyContent: "center" }}>
                <CustomButtonComponent
                  variant="contained"
                  fullWidth
                  onClick={() => navigate(`/admin/jir/${id}`)}
                >
                  JIR
                </CustomButtonComponent>
                {/* <Box sx={{ display: "flex", justifyContent: "center" }}>
          <CustomButtonComponent
            variant="contained"
            fullWidth
            onClick={() => {
              if (ticketDetails?.buildCardUrl) {
                window.open(ticketDetails.buildCardUrl, "_blank");
              }
            }}
            disabled={!ticketDetails?.buildCardUrl}
          >
            Download Build Card
          </CustomButtonComponent>
        </Box> */}
              </Box>
            )}

            {(ticketDetails.status === "OPENED" ||
              ticketDetails.status === "REOPENED") && (
              <Box sx={{ mt: 2, mb: 2 }}>
                <p className="form-header"> Action Taken</p>

                <p> Defect Code</p>
                <SiTextField
                  size="small"
                  fullWidth
                  disabled={true}
                  value={
                    ticketDetails?.defectCode
                      ? `${ticketDetails?.defectCode?.code}-${ticketDetails?.defectCode?.description}`
                      : ""
                  }
                  InputProps={{
                    endAdornment:
                      checkForUserLimit(
                        USER_LIMITS.SERVICE_ENGINEER,
                        userDetails.limits
                      ) ||
                      (checkForUserLimit(
                        USER_LIMITS.ADMIN,
                        userDetails.limits
                      ) &&
                        ticketDetails.status !== "CLOSED" && (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={() => {
                                setUpdateDefectCode(true);
                                loadDefectCodes();
                              }}
                              sx={{ p: 0 }}
                            >
                              <Edit color="primary" fontSize="small" />
                            </IconButton>
                          </InputAdornment>
                        )),
                  }}
                />
                {ticketDetails?.actionCode && (
                  <div>
                    <p> Action Code</p>
                    <SiTextField
                      size="small"
                      fullWidth
                      disabled={true}
                      value={
                        ticketDetails?.actionCode
                          ? `${ticketDetails?.actionCode?.code}-${ticketDetails?.actionCode?.description}`
                          : ""
                      }
                      InputProps={{
                        endAdornment:
                          checkForUserLimit(
                            USER_LIMITS.SERVICE_ENGINEER,
                            userDetails.limits
                          ) ||
                          (checkForUserLimit(
                            USER_LIMITS.ADMIN,
                            userDetails.limits
                          ) &&
                            ticketDetails.status !== "CLOSED" && (
                              <InputAdornment position="end">
                                <IconButton
                                  onClick={() => {
                                    setUpdateActionCode(true);
                                    loadActionCodes();
                                  }}
                                >
                                  <Edit color="primary" />
                                </IconButton>
                              </InputAdornment>
                            )),
                      }}
                    />
                  </div>
                )}
              </Box>
            )}

            <div className="action-form">
              <div>
                {!checkForUserLimit(
                  USER_LIMITS.QUALITY_ADMIN,
                  userDetails.limits
                ) &&
                  ticketDetails.status !== "CLOSED" && (
                    <div>
                      <p>Add Comment</p>
                      <SiTextField
                        value={comment}
                        placeholder="Add Comments"
                        multiline
                        rows={4}
                        variant="outlined"
                        onChange={(e) => setComment(e.target.value)}
                      />
                      <div className="add-comment-bts">
                        <CustomButtonComponent
                          variant="contained"
                          color="primary"
                          size="small"
                          onClick={addComments}
                          disabled={!comment}
                          sx={{ width: "150px" }}
                          startIcon={
                            <Icon
                              icon="iconamoon:comment-dots-duotone"
                              width="1.2rem"
                              height="1.2rem"
                              style={
                                !comment
                                  ? { display: "none" }
                                  : { color: "white" }
                              }
                            />
                          }
                        >
                          Add Comment
                        </CustomButtonComponent>
                        <SiFileUpload id={id} callBack={loadData} />
                      </div>
                    </div>
                  )}

                <p>Final Action</p>
                <SiTextField
                  disabled={true}
                  value={
                    ticketDetails?.actionCode &&
                    convertToCamelCaseFromUnderScore(
                      ticketDetails?.actionCode?.description
                    )
                  }
                  placeholder="Action taken"
                />
                {ticketDetails.status === "CLOSED" && (
                  <Box sx={{ mt: 2, mb: 2 }}>
                    <p> Closed At</p>
                    <SiTextField
                      size="small"
                      fullWidth
                      disabled={true}
                      value={
                        ticketDetails?.closedAt
                          ? `${moment(ticketDetails.closedAt).format(
                              "DD/MM/YYYY"
                            )}`
                          : ""
                      }
                      InputProps={{
                        endAdornment: checkForUserLimit(
                          USER_LIMITS.ADMIN,
                          userDetails.limits
                        ) && (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={() => {
                                setUpdateClosedAt((prevVal) => ({
                                  ...prevVal,
                                  isOpen: true,
                                }));
                              }}
                              sx={{ p: 0 }}
                            >
                              <Edit color="primary" fontSize="small" />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Box>
                )}
                {ticketDetails.stage ===
                  TICKET_STAGES.ENGINE_REPLACEMENT_REQ_SUBMITTED &&
                  checkForUserLimit(USER_LIMITS.ADMIN, userDetails.limits) && (
                    <div>
                      <p>Approver</p>
                      <SiAutocomplete
                        options={approverList}
                        value={lastStageFormData.approver || ""}
                        onChange={(value) =>
                          setLastStageFormData((prevVal) => ({
                            ...prevVal,
                            approver: value,
                          }))
                        }
                        placeholder="Select Approver"
                      />
                      <CustomButtonComponent
                        variant="contained"
                        color="primary"
                        fullWidth
                        sx={{ mt: 2 }}
                        disabled={!lastStageFormData.approver}
                        onClick={() =>
                          assignApprover({
                            approverId: lastStageFormData?.approver?.value,
                          })
                        }
                      >
                        Submit
                      </CustomButtonComponent>
                    </div>
                  )}
                {checkForUserLimit(USER_LIMITS.ADMIN, userDetails.limits) && (
                  <div className="td-buttons-container">
                    {(ticketDetails.status === "RESOLVED" ||
                      ticketDetails.status === "CLOSED") && (
                      <CustomButtonComponent
                        variant="contained"
                        color="primary"
                        onClick={() =>
                          updateTicket({
                            status: "REOPENED",
                          })
                        }
                        fullWidth
                      >
                        Reopen ticket
                      </CustomButtonComponent>
                    )}
                    {(ticketDetails.status === "OPENED" ||
                      ticketDetails.status === "REOPENED") && (
                      <CustomButtonComponent
                        variant="contained"
                        color="success"
                        onClick={() => setOpenModal(true)}
                        fullWidth
                        startIcon={
                          <Icon
                            icon="carbon:task-complete"
                            width="1.2rem"
                            height="1.2rem"
                            style={{ color: "white" }}
                          />
                        }
                      >
                        Resolve Ticket
                      </CustomButtonComponent>
                    )}

                    {/* <CustomButtonComponent
                      variant="outlined"
                      color="error"
                      disabled={
                        ticketDetails.status === "RESOLVED" ||
                        ticketDetails.status === "CLOSED"
                      }
                      onClick={() => updateTicket({ status: "CLOSED" })}
                      fullWidth
                      startIcon={
                        ticketDetails.status !== "RESOLVED" &&
                        ticketDetails.status !== "CLOSED" && (
                          <Icon
                            icon="ph:eye-closed-duotone"
                            width="1.5rem"
                            height="1.5rem"
                            style={{ color: "#d32f2f" }}
                          />
                        )
                      }
                    >
                      Close ticket
                    </CustomButtonComponent> */}
                  </div>
                )}
                {checkForUserLimit(USER_LIMITS.ADMIN, userDetails.limits) &&
                  ticketDetails.stage ===
                    TICKET_STAGES.ENGINE_REPLACEMENT_REJECTED && (
                    <CustomButtonComponent
                      variant="contained"
                      color="warning"
                      onClick={resubmitTicketHandler}
                      fullWidth
                      sx={{ mt: 2 }}
                      startIcon={
                        <Icon
                          icon="carbon:task-complete"
                          width="1.2rem"
                          height="1.2rem"
                          style={{ color: "white" }}
                        />
                      }
                    >
                      Resubmit Ticket
                    </CustomButtonComponent>
                  )}

                {checkForUserLimit(USER_LIMITS.APPROVER, userDetails.limits) &&
                  ticketDetails.stage === TICKET_STAGES.APPROVER_ASSIGNED && (
                    <div style={{ marginTop: "20px" }}>
                      <p className="form-header">Approver Action</p>
                      <Box sx={{ display: "flex" }}>
                        <CustomButtonComponent
                          variant="contained"
                          color="success"
                          sx={{ mr: 1 }}
                          onClick={() => approverOrRejectHandler("APPROVED")}
                          startIcon={<ThumbUpAltTwoToneIcon />}
                        >
                          Accept
                        </CustomButtonComponent>
                        <CustomButtonComponent
                          variant="contained"
                          color="error"
                          sx={{ ml: 1 }}
                          onClick={() => approverOrRejectHandler("REJECTED")}
                          startIcon={<ThumbDownOffAltTwoToneIcon />}
                        >
                          Reject
                        </CustomButtonComponent>
                      </Box>
                    </div>
                  )}
              </div>
            </div>
          </div>
        )}
      </div>

      {!ticketDetails?.jointInspectionReport && (
        <div className="form-con pr">
          <p className="form-header"> View basic request form</p>
          <Grid container sx={{ display: "flex", alignItems: "center", mb: 2 }}>
            <Grid item md={6} xs={12} sx={{ mb: { md: 0, xs: 1 } }}>
              Service Engineer Assigned
            </Grid>
            <Grid item md={6}>
              <SiTextField
                size="small"
                fullWidth
                disabled={true}
                value={ticketDetails.serviceEngineer}
                InputProps={{
                  endAdornment: checkForUserLimit(
                    USER_LIMITS.ADMIN,
                    userDetails.limits
                  ) &&
                    ticketDetails.status !== "CLOSED" &&
                    ticketDetails.stage !==
                      TICKET_STAGES.ENTER_ENGINE_DETAILS &&
                    ticketDetails.stage !==
                      TICKET_STAGES.ENGINE_REPLACEMENT_APPROVED &&
                    ticketDetails.stage !== TICKET_STAGES.OUT_OF_WARRANTY &&
                    ticketDetails.stage !==
                      TICKET_STAGES.COMPLAINT_FORM_SUBMITTED && (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => {
                            setReassign(true);
                            setEngineer(
                              serviceEngineers.find(
                                (s) => s.id === ticketDetails.serviceEngineerId
                              )
                            );
                          }}
                        >
                          <Edit color="primary" />
                        </IconButton>
                      </InputAdornment>
                    ),
                }}
              />
            </Grid>
          </Grid>
          <StaticForm config={BASIC_FORM3(ticketDetails, complaintForm)} />
          {!checkForUserLimit(USER_LIMITS.QUALITY_ADMIN, userDetails.limits) &&
            ticketDetails.status !== "CLOSED" && (
              <div>
                <p>Add Comment</p>
                <SiTextField
                  value={comment}
                  placeholder="Add Comments"
                  multiline
                  rows={4}
                  variant="outlined"
                  onChange={(e) => setComment(e.target.value)}
                />
                <div className="add-comment-bts">
                  <CustomButtonComponent
                    variant="contained"
                    color="primary"
                    size="small"
                    onClick={addComments}
                    disabled={!comment}
                    sx={{ width: "150px" }}
                    startIcon={
                      <Icon
                        icon="iconamoon:comment-dots-duotone"
                        width="1.2rem"
                        height="1.2rem"
                        style={
                          !comment ? { display: "none" } : { color: "white" }
                        }
                      />
                    }
                  >
                    Add Comment
                  </CustomButtonComponent>
                  <SiFileUpload id={id} callBack={loadData} />
                </div>
              </div>
            )}

          {checkForUserLimit(USER_LIMITS.ADMIN, userDetails.limits) && (
            <div className="td-buttons-container">
              {(ticketDetails.status === "RESOLVED" ||
                ticketDetails.status === "CLOSED") && (
                <CustomButtonComponent
                  variant="contained"
                  color="primary"
                  onClick={() =>
                    updateTicket({
                      status: "REOPENED",
                    })
                  }
                  fullWidth
                >
                  Reopen ticket
                </CustomButtonComponent>
              )}
              {(ticketDetails.status === "OPENED" ||
                ticketDetails.status === "REOPENED") && (
                <CustomButtonComponent
                  variant="contained"
                  color="success"
                  onClick={() => setOpenModal(true)}
                  fullWidth
                  startIcon={
                    <Icon
                      icon="carbon:task-complete"
                      width="1.2rem"
                      height="1.2rem"
                      style={{ color: "white" }}
                    />
                  }
                >
                  Resolve Ticket
                </CustomButtonComponent>
              )}

              {/* <CustomButtonComponent
                variant="outlined"
                color="error"
                disabled={
                  ticketDetails.status === "RESOLVED" ||
                  ticketDetails.status === "CLOSED"
                }
                onClick={() => updateTicket({ status: "CLOSED" })}
                fullWidth
                startIcon={
                  ticketDetails.status !== "RESOLVED" &&
                  ticketDetails.status !== "CLOSED" && (
                    <Icon
                      icon="ph:eye-closed-duotone"
                      width="1.5rem"
                      height="1.5rem"
                      style={{ color: "#d32f2f" }}
                    />
                  )
                }
              >
                Close ticket
              </CustomButtonComponent> */}
            </div>
          )}
          {checkForUserLimit(USER_LIMITS.ADMIN, userDetails.limits) &&
            ticketDetails.stage ===
              TICKET_STAGES.ENGINE_REPLACEMENT_REJECTED && (
              <CustomButtonComponent
                variant="contained"
                color="warning"
                onClick={resubmitTicketHandler}
                fullWidth
                sx={{ mt: 2 }}
                startIcon={
                  <Icon
                    icon="carbon:task-complete"
                    width="1.2rem"
                    height="1.2rem"
                    style={{ color: "white" }}
                  />
                }
              >
                Resubmit Ticket
              </CustomButtonComponent>
            )}
        </div>
      )}
      {reassign && (
        <CustomModal
          title="Reassign engineer"
          onClose={() => setReassign(false)}
          classesToPreventClosing={["MuiAutocomplete-option Mui-focused"]}
        >
          <div className="reassign-container">
            <SiAutocomplete
              placeholder="Select engineer"
              value={engineer || ""}
              options={serviceEngineers}
              onChange={(value) => setEngineer(value)}
            />
            <CustomButtonComponent
              variant="contained"
              color="primary"
              size="small"
              disabled={!(engineer && engineer.id)}
              onClick={assignEngineer}
            >
              Update details
            </CustomButtonComponent>
          </div>
        </CustomModal>
      )}
      {updateDefectCode && (
        <CustomModal
          title="Update Defect Code"
          onClose={() => setUpdateDefectCode(false)}
          classesToPreventClosing={["MuiAutocomplete-option Mui-focused"]}
        >
          <div className="reassign-container">
            <SiAutocomplete
              options={defectCodeList}
              value={
                (ticketDetails?.defectCode &&
                  defectCodeList.find(
                    (ele) => ele.label === ticketDetails.defectCode.code
                  )) ||
                ""
              }
              optionLabel="placeholder"
              onChange={(value) => setUpdatedData({ dc: value?.value })}
              placeholder="Select Defect Code"
            />
            <CustomButtonComponent
              variant="contained"
              color="primary"
              size="small"
              disabled={!(updatedData && updatedData.dc)}
              onClick={updateDetailsHandler}
            >
              Update details
            </CustomButtonComponent>
          </div>
        </CustomModal>
      )}
      {updateActionCode && (
        <CustomModal
          title="Update Action Code"
          onClose={() => {
            setUpdateActionCode(false);
            setPartReplacementPayload({
              mode: "",
              scope: "",
              listOfParts: [],
              extra: "",
            });
            setEngineReplacementPayload({
              replacementBy: "",
              engineType: "",
              engineTypeValue: null,
              extraText: "",
              mode: "",
            });
            setSelectedActionCode({});
          }}
          classesToPreventClosing={["MuiAutocomplete-option Mui-focused"]}
        >
          <div className="reassign-container">
            <SiAutocomplete
              options={actionCodeList}
              value={
                (ticketDetails.actionCode &&
                  actionCodeList.find(
                    (ele) => ele.label === ticketDetails.actionCode.code
                  )) ||
                ""
              }
              optionLabel="placeholder"
              onChange={(value) => {
                if (value) {
                  setUpdatedData({ code: value?.value, type: "action" });

                  setSelectedActionCode(value);
                  if (value.label === "A003") {
                    loadParts();
                  }
                } else {
                  setUpdatedData({});
                  setSelectedActionCode({});
                }
              }}
              placeholder="Select Action Code"
            />
            {selectedActionCode.label === "A002" && getActionCode002Elements()}
            {selectedActionCode.label === "A003" && getActionCode003Elements()}

            {selectedActionCode.label !== "A002" &&
              selectedActionCode.label !== "A003" && (
                <Box sx={{ display: "flex", justifyContent: "center" }}>
                  <CustomButtonComponent
                    variant="contained"
                    color="success"
                    disabled={!selectedActionCode.label}
                    onClick={() => updateActionCodeSubmitHandler("action")}
                    sx={{ width: "150px" }}
                  >
                    Submit
                  </CustomButtonComponent>
                </Box>
              )}
          </div>
        </CustomModal>
      )}
      {ticketSeverity.isOpen && (
        <CustomModal
          title="Update Ticket Severity"
          onClose={() =>
            setTicketSeverity({
              isOpen: false,
              severity: "",
            })
          }
          classesToPreventClosing={["MuiAutocomplete-option Mui-focused"]}
        >
          <div className="reassign-container">
            <SiAutocomplete
              placeholder="Select Ticket Severity"
              value={
                (ticketSeverity?.severity &&
                  TICKET_SEVERITY.find(
                    (ele) => ele.value === ticketSeverity.severity
                  )) ||
                ""
              }
              options={TICKET_SEVERITY}
              onChange={(value) =>
                setTicketSeverity((prevVal) => ({
                  ...prevVal,
                  severity: value?.value,
                }))
              }
            />
            <CustomButtonComponent
              variant="contained"
              color="primary"
              size="small"
              disabled={!ticketSeverity?.severity}
              onClick={() => updateSeverityInspection(ticketSeverity.severity)}
            >
              Update details
            </CustomButtonComponent>
          </div>
        </CustomModal>
      )}
      {viewTicket && (
        <CustomModal
          title="Ticket Form"
          onClose={() => setViewTicket(false)}
          classesToPreventClosing={[
            "MuiAutocomplete-option Mui-focused",
            "MuiPickersDay-root MuiPickersDay-dayWithMargin",
            "MuiPickersCalendarHeader-root",
            "MuiPickersCalendarHeader-label",
            "MuiPickersYear-yearButton",
            "MuiPickersLayout-root",
            "MuiPickersLayout-contentWrapper",
            "MuiPickersArrowSwitcher-rightArrowIcon",
            "MuiPickersArrowSwitcher-leftArrowIcon",
            "MuiPickersCalendarHeader-switchViewIcon",
            "MuiDayCalendar-weekContainer",
            "MuiDayCalendar-weekDayLabel",
            "Mui-selected",
            "MuiPickersDay-dayWithMargin",
          ]}
          contentClassName="form-modal"
        >
          <ViewBasicForm
            ticketDetails={ticketDetails}
            details={complaintForm}
            loadTicketData={loadData}
          />
        </CustomModal>
      )}
      {isUpdateTicket?.isOpen && (
        <CustomModal
          title="Update Ticket Details"
          onClose={() =>
            setIsUpdateTicket({ isOpen: false, type: "", value: "" })
          }
          classesToPreventClosing={["MuiAutocomplete-option Mui-focused"]}
        >
          <p>{isUpdateTicket?.type === "listNumber" && "Enter List Number"}</p>
          <p>{isUpdateTicket?.type === "plant" && "Enter Plant"}</p>
          <p>
            {isUpdateTicket?.type === "underWarranty" &&
              "Update Warranty Status"}
          </p>

          <div className="reassign-container">
            {isUpdateTicket?.type === "underWarranty" ? (
              <SiAutocomplete
                value={partReplacementPayload.listOfParts}
                options={WARRANTY_STATUS}
                placeholder="Warranty Status"
                onChange={(event) => {
                  if (event) {
                    setIsUpdateTicket((prevVal) => ({
                      ...prevVal,
                      value: event.value,
                    }));
                  } else {
                    setIsUpdateTicket((prevVal) => ({
                      ...prevVal,
                      value: "",
                    }));
                  }
                }}
              />
            ) : (
              <SiTextField
                name={isUpdateTicket?.type}
                onChange={(e) => {
                  setIsUpdateTicket((prevVal) => ({
                    ...prevVal,
                    value: e.target.value,
                  }));
                }}
              />
            )}

            <CustomButtonComponent
              variant="contained"
              color="primary"
              size="small"
              disabled={
                isUpdateTicket?.type === "underWarranty"
                  ? isUpdateTicket?.value === null ||
                    isUpdateTicket?.value === ""
                  : !isUpdateTicket?.value
              }
              onClick={() => {
                const payload = {
                  [isUpdateTicket.type]: isUpdateTicket.value,
                };
                updateTicket(payload);
                setIsUpdateTicket({ isOpen: false, type: "", value: "" });
              }}
            >
              Update details
            </CustomButtonComponent>
          </div>
        </CustomModal>
      )}
      {updateClosedAt?.isOpen && (
        <CustomModal
          title="Update Ticket Closure Date"
          onClose={() => setUpdateClosedAt({ isOpen: false, date: "" })}
          classesToPreventClosing={["MuiAutocomplete-option Mui-focused"]}
        >
          <div className="reassign-container">
            <SiTextField
              name="closedAt"
              type="date"
              onChange={(e) => {
                setUpdateClosedAt((prevVal) => ({
                  ...prevVal,
                  date: e.target.value,
                }));
              }}
            />
            <CustomButtonComponent
              variant="contained"
              color="primary"
              size="small"
              disabled={!updateClosedAt?.date}
              onClick={() => {
                updateTicket({ closedAt: updateClosedAt.date });
                setUpdateClosedAt({ isOpen: false, date: "" });
              }}
            >
              Update details
            </CustomButtonComponent>
          </div>
        </CustomModal>
      )}
      {updateInvoiceDate?.isOpen && (
        <CustomModal
          title="Update Invoice Date"
          onClose={() => setUpdateInvoiceDate({ isOpen: false, date: "" })}
          classesToPreventClosing={["MuiAutocomplete-option Mui-focused"]}
        >
          <div className="reassign-container">
            <SiTextField
              name="invoiceDate"
              type="date"
              value={updateInvoiceDate.date}
              onChange={(e) => {
                setUpdateInvoiceDate((prevVal) => ({
                  ...prevVal,
                  date: e.target.value,
                }));
              }}
            />
            <CustomButtonComponent
              variant="contained"
              color="primary"
              size="small"
              disabled={!updateInvoiceDate?.date}
              onClick={() => {
                updateTicket({ invoiceDate: updateInvoiceDate.date });
                setUpdateInvoiceDate({ isOpen: false, date: "" });
              }}
            >
              Update details
            </CustomButtonComponent>
          </div>
        </CustomModal>
      )}
      {openModal && (
        <CustomModal
          title="Resolve ticket"
          onClose={() => {
            setOpenModal(false);
            setMessage("");
          }}
        >
          <div className="resolve-msg">
            <SiTextField
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              fullWidth
              size="small"
              multiline
              rows={4}
              placeholder="Resolve message"
              sx={{ marginTop: 2 }}
            />
            <Stack
              direction="row"
              spacing={2}
              sx={{ mt: 3, justifyContent: "flex-end" }}
            >
              <CustomButtonComponent
                variant="outlined"
                sx={{ width: "150px" }}
                onClick={() => {
                  setOpenModal(false);
                  setMessage("");
                }}
                color="error"
                startIcon={
                  <Icon
                    icon="hugeicons:cancel-circle-half-dot"
                    width="1.2rem"
                    height="1.2rem"
                    style={{ color: "#d32f2f" }}
                  />
                }
              >
                Cancel
              </CustomButtonComponent>

              <CustomButtonComponent
                variant="contained"
                color="success"
                onClick={() => {
                  setMessage("");
                  setOpenModal(false);
                  updateTicket({
                    status: "RESOLVED",
                    resolveMessage: message,
                  });
                }}
                sx={{ width: "150px" }}
                startIcon={
                  <Icon
                    icon="carbon:task-complete"
                    width="1.2rem"
                    height="1.2rem"
                    style={{ color: "white" }}
                  />
                }
              >
                {ticketDetails.status === "RESOLVED" ||
                ticketDetails.status === "CLOSED"
                  ? "Reopen ticket"
                  : "Resolve ticket"}
              </CustomButtonComponent>
            </Stack>
          </div>
        </CustomModal>
      )}
    </div>
  );
};

export default BasicInfo2;
